import { Link } from "react-router-dom";
import { Gauge, Pulse, ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";

const CHECKS = ["Seasonal inspection", "Airflow evaluation", "Filter condition", "Electrical checks", "Blower & inducer evaluation", "Temperature rise", "Pressure measurements", "Combustion review", "Maintenance history"];

export const PreventiveSection = () => (
  <section data-testid="preventive-section" className="relative border-t border-white/10 bg-panel/40 py-24 md:py-32">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-6 md:px-12 lg:grid-cols-[1fr_1fr] lg:items-center">
      <Reveal>
        <div className="mb-4 flex items-center gap-3">
          <span className="h-px w-10 bg-brand-cyan" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cyan">Preventive Maintenance</span>
        </div>
        <h2 className="font-display text-4xl font-extrabold leading-[0.98] tracking-tight md:text-5xl">
          Prevent failure before it becomes an emergency.
        </h2>
        <p className="mt-6 max-w-lg font-body text-base leading-relaxed text-slatex-300">
          Maintenance built on measurement, not checkboxes. We document the health of the system over time so small drifts get caught before they become no-heat calls.
        </p>
        <div className="mt-8 flex flex-wrap gap-2">
          {CHECKS.map((c) => (
            <span key={c} className="border border-white/12 bg-ink px-3 py-1.5 font-mono text-[11px] uppercase tracking-wide text-slatex-300">{c}</span>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="relative border border-white/10 bg-ink p-8 panel-glow md:p-10">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center border border-brand-cyan/40 bg-brand-cyan/10">
              <Pulse size={20} weight="duotone" className="text-brand-cyan" />
            </span>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-brand-cyan">Innovation Layer</span>
          </div>
          <h3 className="mt-6 font-display text-2xl font-bold md:text-3xl">Furnace Sentinel</h3>
          <p className="mt-4 font-body text-sm leading-relaxed text-slatex-300">
            Advanced remote monitoring and predictive maintenance capabilities are under development through our Furnace Sentinel platform — the same technical DNA behind our diagnostics.
          </p>
          <div className="mt-8 grid grid-cols-3 gap-px border border-white/10 bg-white/10">
            {[{ i: <Gauge size={18} weight="duotone" />, l: "Monitor" }, { i: <Pulse size={18} weight="duotone" />, l: "Predict" }, { i: <Gauge size={18} weight="duotone" />, l: "Prevent" }].map((x) => (
              <div key={x.l} className="flex flex-col items-center gap-2 bg-ink py-5 text-brand-cyan">
                {x.i}<span className="font-mono text-[10px] uppercase tracking-widest text-slatex-300">{x.l}</span>
              </div>
            ))}
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <span className="inline-block border border-white/12 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-slatex-500">In Development</span>
            <a href="#furnace-sentinel" data-testid="sentinel-see-live" className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-brand-cyan transition-colors hover:text-white">
              See it live
              <ArrowRight size={13} weight="bold" className="transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default PreventiveSection;
